import React from 'react';
import { Team } from '../components/Team';
import { Contact } from '../components/Contact';
import { PageHeader } from '../components/PageHeader';

export const TeamPage: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <PageHeader title="Unser//Team" subtitle="Crew" />
      <Team />
      <Contact />
    </div>
  );
};